import { useQuery, UseQueryResult } from 'react-query';
import { KiloClass, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseClassMonthProps {
  start: string;
  end: string;
  coaches?: string[];
  locations?: string[];
  eventTypes?: string[];
}

function useClassMonth({
  start,
  end,
  coaches,
  locations,
  eventTypes,
}: IUseClassMonthProps): UseQueryResult<{ data: Array<KiloClass> }> {
  const params: UrlParams = { start, end };

  if (coaches && coaches.length > 0) {
    params.coaches = coaches.join(',');
  }

  if (locations && locations.length > 0) {
    params.locations = locations.join(',');
  }

  if (eventTypes && eventTypes.length > 0) {
    params.event_types = eventTypes.join(',');
  }

  return useQuery(
    ['classes', 'month', start, end, coaches, eventTypes, locations],
    () => client.get(`kilo-classes/month/?${encodeUrlParams(params)}`),
    {
      enabled: !!start && !!end && end > start,
    },
  );
}

export default useClassMonth;
